<template>
  <div class="checkbox-widget container" style="padding-left: 0px; padding-right: 0px;">
    <div class="row align-items-center checkbox-widget-row">
      <div
        :class="`col-${props.nameWidth}`"
        v-if="props.showName"
      >
        <label :for="props.id" class="form-label mb-0 fw-normal checkbox-widget-label">{{
          props.name
        }}</label>
      </div>
      <div class="col checkbox-widget-control-col">
        <div class="checkbox-wrapper d-flex align-items-center">
          <input v-if="props.isVisible"
            class="form-check-input check-controller"
            type="checkbox"
            :id="props.id"
            :value="props.value"
            :checked="props.checked"
            :disabled="props.disabled"
            @change="onCheckboxChange"
          />
          <span v-if="props.valueText" class="checkbox-text ms-2">{{ props.valueText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  watch,
  onMounted,
} from 'vue';

const emit = defineEmits(['onChange', 'update:checked']);

const props = defineProps({
  name: {
    type: String,
    required: true,
    default: '',
  },
  id: {
    type: String,
    required: true,
    default: 'checkbox-widget',
  },
  value: {
    type: [String, Number, Boolean],
    default: '',
  },
  checked: {
    type: Boolean,
    default: false,
  },
  showName: {
    type: Boolean,
    default: true,
  },
  nameWidth: {
    type: Number,
    default: 3,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  valueText: {
    type: String,
    default: '',
  },
  isVisible: {
    type: Boolean,
    default: true,
  },
});

const isChecked = ref(props.checked);

const onCheckboxChange = (event) => {
  if (props.disabled) {
    return;
  }
  
  isChecked.value = event.target.checked;
  
  // v-model 지원
  emit('update:checked', isChecked.value);
  
  // onChange 이벤트
  emit('onCheckboxChanged', {
    checked: isChecked.value,
    value: props.value,
    event: event
  });
};

// props.checked가 변경될 때 내부 상태 동기화
watch(() => props.checked, (newValue) => {
  isChecked.value = newValue;
});

onMounted(() => {
  isChecked.value = props.checked;
});
</script>

<style scoped>
.checkbox-widget-row {
  min-height: 44px;
}

.checkbox-widget-label {
  line-height: 1.2;
}

.checkbox-widget-control-col {
  padding-top: 0;
  padding-bottom: 0;
}

.checkbox-wrapper {
  position: relative;
  left: 0;
  width: 100%;
  min-height: 44px;
}

.check-controller {
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}

.check-controller:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-check-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

/* Slider와 동일한 정렬을 위한 스타일 */
.form-check-input {
  margin-top: 0;
  margin-bottom: 0;
  vertical-align: middle;
}

/* 전체 컨테이너의 여백 조정 */
.container {
  margin-bottom: 0;
}

.row {
  margin-bottom: 0;
}

/* col의 여백 조정 */
.col {
  margin-bottom: 0;
  padding-bottom: 0;
}
</style>
